import { LoadSpinner } from '@calizahq/react-components-v2'
import { AgentQueries } from '@sales-app/graphql/queries/agent.queries'
import { Table } from '@shared/components'
import React, { useMemo } from 'react'

import { useUserContext } from '@/context'
import { AgentRoles } from '@/context/user/user.types'
import { useGraphql } from '@/hooks/useGraphql'

import { BottomBar } from '../BottomBar/BottomBar'
import { AgentColumns } from './Agents.data'
import { FilterBar } from './Filters/FilterBar'

export const Agents = () => {
  const { user } = useUserContext()
  const {
    data: agentData,
    isLoading,
    refetch,
  } = useGraphql<AgentQueries.GET_AGENTS.Response>(AgentQueries.getAgents.name, AgentQueries.getAgents(), {})

  const data = useMemo(() => {
    return agentData?.agents ? agentData?.agents : []
  }, [agentData])

  const columns = useMemo(() => {
    return AgentColumns(refetch)
  }, [refetch])

  return (
    <>
      {user?.agent?.role === AgentRoles.SUPERVISOR ? (
        <>
          <div className="mb-6 flex w-full flex-col p-4 md:p-8">
            <div className="mb-2 flex w-full items-center justify-between md:mb-4 md:flex-row">
              <h1 className="mb-3 text-header-lg">Agents</h1>
            </div>
            <FilterBar refetchOnSuccess={refetch} />
            {isLoading ? (
              <div className="flex h-20 w-full items-center justify-center">
                <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
              </div>
            ) : (
              <div className="">
                <Table columns={columns as any} data={data} />
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="m-auto">You Do Not Have Permission to Access Agents</div>
      )}
      <BottomBar />
    </>
  )
}
